import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { PointStoreNavigationBarService } from '../../services/point-store-navigation-bar.service';
import { PointStoreProductValidationService } from '../../services/point-store-product-validation.service';
import { PointStoreProductEditSaveService } from '../../services/point-store-product-edit-save.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { CvDialogService } from 'src/app/reusables/confirm-dialog/cv-dialog.service';
import { CvConfigurationService } from '../../../../../reusables/services/cv-configuration.service';
import { PointStoreProductLandingPageComponent } from '../point-store-product-landing-page/point-store-product-landing-page.component';
import { PointStoreCategoriesService } from '../../services/point-store-categories.service';
import { PointStoreCxoneSidebarComponent } from '../point-store-cxone-sidebar/point-store-cxone-sidebar.component';
import { CvPointStoreProductService } from 'src/app/gamification/cv-marketplace-admin/services/cv-point-store-product.service';
import { AngularAssignToolService } from 'src/app/reusables/assign-tool/angular-assign-tool.service';

@Component({
    selector: 'cv-point-store-edit',
    templateUrl: './point-store-edit.component.html',
    styleUrls: ['./point-store-edit.component.scss']
})
export class PointStoreEditComponent implements OnInit {

    psnbf: any = null;
    pspes: any = null;
    boundedSetEditFrame = this.setEditFrame.bind(this);
    boundedCancelEditFrame = this.cancelEditFrame.bind(this);
    boundedSave = this.savePointStoreProduct.bind(this);
    pscs: any = null;
    boundedCallParentFunctions = this.parentFunctionsCall.bind(this);

    @ViewChild(PointStoreProductLandingPageComponent, { static: false }) psProductLandingPage: PointStoreProductLandingPageComponent;
    @ViewChild("sidebar", {static: false}) sidebar: PointStoreCxoneSidebarComponent;
    private groupInfo = {
        groupLevel: 2
    };

    constructor(
        private pointStoreProductValidationService: PointStoreProductValidationService,
        private pointStoreProductEditSaveService: PointStoreProductEditSaveService,
        private pointStoreNavigationBarService: PointStoreNavigationBarService,
        private pointStoreProductEditService: PointStoreProductEditService,
        private cvLocalizationService: CVLocalizationService,
        private dialogService: CvDialogService,
        private cdr: ChangeDetectorRef,        
        public cvConfigurationService: CvConfigurationService,
        private pointStoreCategoriesService: PointStoreCategoriesService,
        private cvPointStoreProductService: CvPointStoreProductService,
        private service: AngularAssignToolService,
    ) { }

    ngOnInit(): void {
        this.psnbf = this.pointStoreNavigationBarService.data;
        this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
        this.pscs = this.pointStoreCategoriesService.data;
        this.getCurrentPageName();
        if(this.cvConfigurationService.isCxOne){
            this.getTeam();
        }
    }

    async setEditFrame(index) {
        let currentFrame = this.pointStoreNavigationBarService.getSelectedFrame();
        let validation = this.pointStoreProductValidationService.getValidationOfStep(currentFrame);
        if (validation.succeeded) {
            this.pointStoreNavigationBarService.setSelectedFrame(index);
        } else {
            let validationVal = await this.pointStoreProductValidationService.showValidationErrorDialog(validation);
            const response = String(validationVal);
            if (response == "yes") {
                this.pointStoreNavigationBarService.setSelectedFrame(index);
            } else if (response === 'ok') {
                //if validation triggered in upload picture step and validation.skip is true
                if (validation.skip) {
                    this.pointStoreNavigationBarService.setSelectedFrame(3);
                    return;
                }
                this.pointStoreNavigationBarService.setSelectedFrame(currentFrame);
            }
        }
    };

    cancelEditFrame() {
        this.pointStoreProductValidationService.validatePointStoreProductCancelButton();
    };

    backEditFrame(index) {
        this.pointStoreProductValidationService.setNavigationPage(index);
    };

    async savePointStoreProduct() {
        if (this.pspes.isSavingProduct)
            return;

        this.pspes.isSavingProduct = true;

        let currentFrame = this.pointStoreNavigationBarService.getSelectedFrame();
        const validation = this.pointStoreProductValidationService.validatePointStoreProductEditPage();
        
        if (validation.succeeded) {
            this.pointStoreProductEditSaveService.savePointStoreProduct().then((result) => {
                this.cdr.detectChanges();
                this.psProductLandingPage.filterChanged();
                this.pspes.isSavingProduct = false;
                //boolean variable to decide if reload the categories in the product info form, false to no reload
                this.pscs.isCategoriesChange = false;
                //reset category list on the product info form
                this.pointStoreCategoriesService.resetCategoriesList();
            });
        } else {
            this.pspes.isSavingProduct = false;
            //if validation triggered in upload picture step and validation.skip is true
            if (validation.skip) {
                let validationVal = await this.pointStoreProductValidationService.showValidationErrorDialog(validation);
                const response = String(validationVal);
                if (response === 'ok') {
                    this.pointStoreNavigationBarService.setSelectedFrame(3);   
                }
            }
        }
    };

    removePointStoreProduct() {
        this.pointStoreProductEditSaveService.removePointStoreProduct();
    };

    getCurrentPageName() {
        const path: string = window.location.pathname;
        const splitPath: string[] = path.split('/');
        if (splitPath.length > 2) {
          const pageName = splitPath[2].replace('.aspx', '');
          if(pageName.endsWith('CXOne')){
            this.cvConfigurationService.isCxOne = true;
          }
        }
    }

    async getTeam(){
        /* The line `const teams = await this.service.loadEmpGroups(2);` is calling the `loadEmpGroups`
            method of the `service` object with the argument `2`. According to the CXONE requirements: 
            "When agents are assigned to products, the Employee Group table should display the Agent and 
            Team columns in accordance with the US acceptance criteria." Therefore, the "groupLevel = 2" parameter
            is sent to retrieve the information of the agents' teams. */
        const teams = await this.service.loadEmpGroups(this.groupInfo.groupLevel);
        
        this.cvPointStoreProductService.setTeams(teams);
    }

    parentFunctionsCall(): void {
        this.psProductLandingPage.filterChanged();
    }
}

